import axios from "axios";

const API = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor - 401 hatasını yakalar ve otomatik yeniler
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 401 Unauthorized aldık ve bu istek daha önce tekrar edilmediyse
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          // Doğrudan axios ile istek atıyoruz, API instance'ı kullanmıyoruz (sonsuz döngüyü önlemek için)
          const res = await axios.post("/api/token/refresh/", {
            refresh: refreshToken,
          });

          const newAccessToken = res.data.access;
          const newRefreshToken = res.data.refresh;

          localStorage.setItem("token", newAccessToken);
          if (newRefreshToken) {
            localStorage.setItem("refreshToken", newRefreshToken);
          }

          // Yeni token'ı header'a ekleyip orijinal isteği tekrar çalıştırıyoruz
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return API(originalRequest);
        } catch (refreshError) {
          // Refresh token'ın da süresi bittiyse oturumu sonlandır
          console.error("Refresh token geçerliliğini yitirmiş:", refreshError);
          localStorage.clear();
          window.location.href = "/login";
          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);

export default API;
